import React, { useEffect, useState } from 'react';
import userProfile from '../../../assets/images/userProfile.svg';
import CustomerCall from '../../../assets/images/call.svg';
import CustomerSms from '../../../assets/images/sms.svg';
import CustomerLocation from '../../../assets/images/location.svg';
import { Status } from '../../../components';
import Options from '../../../assets/images/Options.svg';
import DeleteIcon from '../../../assets/images/delete_icon.svg';
import EditIcon from '../../../assets/images/edit_Icon.svg';
import ActiveOptions from '../../../assets/images/activeOptions.svg';
import HoverOptions from '../../../assets/images/hoverOptions.svg';
import HoverDelete from '../../../assets/images/hoverDelete.svg';
import HoverEdit from '../../../assets/images/hoverEdit.svg';
import Popup from '../../../components/RenewPlan';
import { Link } from 'react-router-dom';
import {
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useHook as CustomerHook } from './useHook';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Unauthorized } from '../../../components/index';
import { ErrorMessage } from '../../../permissionErrorMessage/PermissionMessage';
interface Props {
  pagePermissionIDs: unknown;
}

const Edit: React.FC<Props> = ({ pagePermissionIDs }) => {
  const userRole = localStorage.getItem('role');
  const canUpdateSubscription =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('customers::updateSubscription');
  const canCustomersGet =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('customers::get');

  const {
    fetchCustomerDetails,
    fetchDealerCustomerDetails,
    updateSubscription,
    updateDealerSubscription,
  } = CustomerHook();
  const { id } = useParams();
  const { customerDetails } = useSelector(
    (state: any) => state.customerManagement,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [actionimageActive, setactionimageActive] = useState<number | null>(
    null,
  );
  const [actionimageHoverd, setActionimageHoverd] = useState<number | null>(
    null,
  );
  const [menuItemHoverd, setMenuItemHovered] = useState<string | null>(null);
  const [isRenewDialogOpen, setIsRenewDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [unitId, setUnitId] = useState(null);
  //getCustomerDetails
  const getCustomerDetails = async () => {
    if (userRole === 'dealer') {
      await fetchDealerCustomerDetails({ customerID: id });
    } else {
      if (canCustomersGet) {
        await fetchCustomerDetails({ customerID: id });
      }
    }
  };

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['customers::get'] || ''}</li>
      </ul>
    </section>
  );

  useEffect(() => {
    getCustomerDetails();
  }, [id, canCustomersGet]);

  //menu
  const handleMenuClick = (event: any, index: number, unitID: any) => {
    setAnchorEl(event.currentTarget);
    setactionimageActive(index);
    setUnitId(unitID);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setactionimageActive(null);
    setActionimageHoverd(null);
  };

  const actionimageMouseEnter = (id: number) => {
    setActionimageHoverd(id);
  };

  const actionimageMouseLeave = () => {
    setActionimageHoverd(null);
  };
  const MenuItemEnter = (item: string) => {
    setMenuItemHovered(item);
  };

  const MenuItemLeave = () => {
    setMenuItemHovered(null);
  };

  //renew
  const handleRenewMenuItemClick = () => {
    setIsRenewDialogOpen(true);
    handleMenuClose();
  };

  const handleRenewConfirm = async (data: any) => {
    const payload = {
      customerID: id,
      unitID: unitId,
      startDate: data.startDate,
      endDate: data.endDate,
    };
    if (userRole === 'dealer') {
      await updateDealerSubscription(payload);
    } else {
      await updateSubscription(payload);
    }
    setIsRenewDialogOpen(false);
    setUnitId(null);
  };

  const handleRenewCancel = () => {
    setIsRenewDialogOpen(false);
    setUnitId(null);
  };

  //cancel plan
  const handleCancelMenuItemClick = () => {
    setIsCancelDialogOpen(true);
    handleMenuClose();
  };

  const handleCancelPlanConfirm = () => {
    setIsCancelDialogOpen(false);
    setUnitId(null);
  };

  const handleCloseCancelPlan = () => {
    setIsCancelDialogOpen(false);
    setUnitId(null);
  };
  //dateformat
  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  return (
    <>
      {!canCustomersGet ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          <section className="customer_management_name-edit">
            <div className="customer_management_name-edit-img">
              <img
                src={
                  customerDetails?.image ? customerDetails?.image : userProfile
                }
                
 onError={e => {
    // Prevent infinite loop if fallback also fails
    e.currentTarget.onerror = null;
    // Set fallback SVG or image from assets or public folder
    e.currentTarget.src = userProfile;
  }}
                alt="customer"
              />
            </div>
            <div className="customer_management_name-edit-customer">
              <h5>
                {' '}
                {customerDetails?.firstName && customerDetails?.lastName
                  ? `${customerDetails.firstName} ${customerDetails.lastName}`
                  : ' '}
              </h5>
              <div className="customer_management_name-edit-address">
                <div className="customer_management_name-edit-address-contact">
                  <div className="customer_management_name-edit-address-contact-img">
                    <img
                      src={CustomerCall}
                      width="24px"
                      height="24px"
                      alt="CustomerCall"
                    />{' '}
                    <h6>{customerDetails?.mobileNo || ' '}</h6>
                  </div>
                  <div className="customer_management_name-edit-address-contact-img">
                    <img
                      src={CustomerSms}
                      width="24px"
                      height="24px"
                      alt="CustomerSms"
                    />{' '}
                    <h6>{customerDetails?.email || ' '}</h6>
                  </div>
                </div>
                <div className="customer_management_name-edit-address-contact-img">
                  <img
                    src={CustomerLocation}
                    width="24px"
                    height="24px"
                    alt="CustomerLocation"
                  />{' '}
                  <h6>
                    {`${customerDetails?.address || ''} ${customerDetails?.state || ''} ${customerDetails?.country || ''}`}
                  </h6>
                </div>
              </div>
            </div>
          </section>

          <TableContainer className="controller_table" component={Paper}>
            <Table>
              <TableHead className="controller_tableheader">
                <TableRow>
                  <TableCell>Serial No</TableCell>
                  <TableCell>Equipment Type</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Sub-Category</TableCell>
                  <TableCell>Subscription status</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Modified</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerDetails?.equipments?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="body1" align="left">
                        No Data found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  customerDetails?.equipments?.map(
                    (data: any, index: number) => (
                      <TableRow key={index}>
                        <TableCell className="cutomer_edit-serial-number">
                          <Link
                            to={`/customermanagement/equipmentdetails/${data?.serialNumber}/${data?.unitID}`}
                            state={{ customerId: id }}
                          >
                            {data?.serialNumber}
                          </Link>
                        </TableCell>
                        <TableCell>
                          <p className="controller_management_model-data">
                            {data?.equipmentModel}
                          </p>
                        </TableCell>

                        <TableCell>
                          <p className="controller_management_model-data">
                            {data?.category}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="controller_management_model-data">
                            {data?.subCategory}
                          </p>
                        </TableCell>
                        <TableCell>
                          <Status
                            status={data?.subscriptionStatus || 'Deactivate'}
                          />
                        </TableCell>
                        <TableCell>
                          <p className="controller_management_model-data">
                            {data?.startDate ? formatDate(data?.startDate) : ''}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="controller_management_model-data">
                            {data?.endDate ? formatDate(data?.endDate) : ''}
                          </p>
                        </TableCell>
                        <TableCell>
                          <div className="inventory-modifiedfield">
                            <p className="controller_management_model-data">
                              {data?.modified || ''}
                            </p>
                            <button
                              aria-controls="simple-menu"
                              aria-haspopup="true"
                              onClick={(e) =>
                                handleMenuClick(e, index, data?.unitID)
                              }
                            >
                              {actionimageActive === index ? (
                                <img src={ActiveOptions} alt="Option img" />
                              ) : (
                                <img
                                  key={index}
                                  src={
                                    actionimageHoverd === index
                                      ? HoverOptions
                                      : Options
                                  }
                                  alt="Option img"
                                  onMouseEnter={() =>
                                    actionimageMouseEnter(index)
                                  }
                                  onMouseLeave={actionimageMouseLeave}
                                />
                              )}
                            </button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ),
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            className="dashboard-menu"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {canUpdateSubscription && (
              <MenuItem
                onClick={handleRenewMenuItemClick}
                onMouseEnter={() => MenuItemEnter('renew')}
                onMouseLeave={MenuItemLeave}
                className="menuItem edit_icon"
              >
                <img
                  src={menuItemHoverd === 'renew' ? HoverEdit : EditIcon}
                  alt="renew"
                />
                Renew Plan
              </MenuItem>
            )}
            {/* <MenuItem
              onClick={handleCancelMenuItemClick}
              onMouseEnter={() => MenuItemEnter('cancel')}
              onMouseLeave={MenuItemLeave}
              className="menuItem delete_icon"
            >
              <img
                src={menuItemHoverd === 'cancel' ? HoverDelete : DeleteIcon}
                alt="cancel"
              />
              Cancel Plan
            </MenuItem> */}
          </Menu>

          <Popup
            open={isRenewDialogOpen}
            handleClose={handleRenewCancel}
            handleConfirm={handleRenewConfirm}
            page="Renew"
          />
          <Popup
            open={isCancelDialogOpen}
            handleClose={handleCloseCancelPlan}
            handleConfirm={handleCancelPlanConfirm}
            page="Cancel"
          />
        </>
      )}
    </>
  );
};

export default Edit;
